"use client";

import { c as _c } from "react/compiler-runtime";
import { RadioGroupItem } from "@/components/ui/radio-group";
import { ConnectorLogo } from "./ConnectorLogo";
interface ConnectorOptionRowProps {
  optionId: string;
  value: string;
  title: string;
  subtitle?: string;
  isSelected: boolean;
  disabled?: boolean;
  connectorType: string;
  logoName: string;
  logoUrl?: string;
}
export function ConnectorOptionRow(t0) {
  const $ = _c(21);
  const {
    optionId,
    value,
    title,
    subtitle,
    isSelected,
    disabled,
    connectorType,
    logoName,
    logoUrl
  } = t0;
  const t1 = `flex items-center gap-3 px-4 py-3 transition-colors ${disabled ? "cursor-not-allowed opacity-60" : isSelected ? "cursor-pointer bg-blue-50 dark:bg-blue-500/10" : "dark:hover:bg-ds-neutral-800/50 hover:bg-ds-surface-hover cursor-pointer"}`;
  let t2;
  if ($[0] !== disabled || $[1] !== optionId || $[2] !== value) {
    t2 = <RadioGroupItem value={value} id={optionId} disabled={disabled} />;
    $[0] = disabled;
    $[1] = optionId;
    $[2] = value;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== connectorType || $[5] !== logoName || $[6] !== logoUrl) {
    t3 = <div className="flex-shrink-0"><ConnectorLogo type={connectorType} name={logoName} logoUrl={logoUrl} size="base" /></div>;
    $[4] = connectorType;
    $[5] = logoName;
    $[6] = logoUrl;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== title) {
    t4 = <div className="body-sm-medium truncate">{title}</div>;
    $[8] = title;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== subtitle) {
    t5 = subtitle ? <div className="text-ds-text-muted text-xs">{subtitle}</div> : null;
    $[10] = subtitle;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t4 || $[13] !== t5) {
    t6 = <div className="min-w-0 flex-1">{t4}{t5}</div>;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== optionId || $[16] !== t1 || $[17] !== t2 || $[18] !== t3 || $[19] !== t6) {
    t7 = <label htmlFor={optionId} className={t1}>{t2}{t3}{t6}</label>;
    $[15] = optionId;
    $[16] = t1;
    $[17] = t2;
    $[18] = t3;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
}